/* "Clear cart": removes everything in the cart. First tap asks, second tap clears (no pop-up dialogs). */
if (!window.__clearCartWired) {
  window.__clearCartWired = true;
  const ASK = 'Tap again to clear everything';
  const reset = (btn) => { btn.dataset.confirm = '0'; btn.classList.remove('is-confirm'); btn.textContent = btn.dataset.label || 'Clear cart'; };
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-clear-cart]');
    if (!btn) return;
    e.preventDefault();
    if (!btn.dataset.label) btn.dataset.label = btn.textContent.trim();
    if (btn.dataset.confirm !== '1') {
      btn.dataset.confirm = '1';
      btn.classList.add('is-confirm');
      btn.textContent = ASK;
      clearTimeout(btn._t);
      btn._t = setTimeout(() => reset(btn), 4000);
      return;
    }
    clearTimeout(btn._t);
    btn.disabled = true;
    btn.textContent = 'Clearing…';
    try {
      const res = await fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } });
      if (!res.ok) throw new Error('clear failed');
      try { sessionStorage.removeItem('pym-bags'); } catch (err) { /* the machine just starts empty anyway */ }
      window.location.reload();
    } catch (err) {
      btn.disabled = false;
      reset(btn);
      btn.textContent = 'Could not clear, try again';
    }
  });
}
